var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"pc-box"},[_c('Header'),_c('Banner'),_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-left"},[_c('router-view')],1),_c('div',{staticClass:"content-right"},[_c('ContentR')],1)]),_c('Suspension'),_c('Footer'),_c('Mobile')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }